interface BadgeTranslations {
  [key: string]: {
    [key: string]: string
  }
}

// There are plans to make the logic for the pill badge text fully automated in Shopify,
// so theoretically we'll get a single translated value in the API response. Until then...
export const badgeTranslations: BadgeTranslations = {
  new: {
    fr: 'Nouveauté',
    de: 'Neu',
    it: 'Novità',
    es: 'Nuevo',
  },
  backInStock: {
    fr: 'À nouveau dispo',
    de: 'Wieder da',
    it: 'Nuovamente disponibile',
    es: 'Vuelta en stock',
  },
  sale: {
    fr: 'Promo',
    de: 'Sale',
    it: 'Promo',
    es: 'Oferta',
  },
  soldOut: {
    fr: 'Épuisé',
    de: 'Ausverkauft',
    it: 'Esaurito',
    es: 'Agotado',
  },
  comingSoon: {
    fr: 'Prochainement',
    de: 'Kommt bald',
    it: 'In arrivo',
    es: 'Próximamente',
  },
};